import { css } from 'linaria';
import { styled } from 'linaria/react';
import { strictBreakpoints } from '../../../../../media';

export const PicContainer = styled.div<{ imageUrl: string }>`
	display: flex;
	align-items: flex-end;
	min-height: 240px;
	padding: 16px;
	background-image: ${({ imageUrl }) => `url(${imageUrl})`};
	background-size: cover;
	border-radius: 8px;
	${strictBreakpoints.onlyMobile} {
		min-height: 160px;
	}

	.price {
		padding: 8px 12px;
		font-weight: 500;
		font-size: 16px;
		font-style: normal;
		line-height: 24px;
		letter-spacing: 0.05px;
		background: var(--background-primary);
		border-radius: 4px;

		span {
			font-weight: 500;
			font-size: 12px;
			font-style: normal;
			line-height: 16px;
			letter-spacing: 0.2px;
		}
	}
`;

export const galleryStyles = css`
	display: grid;
	grid-gap: 16px;
	grid-template-areas:
		'item1 item1 item1 item2 item2 item2'
		'item3 item3 item4 item4 item5 item5';
	grid-template-rows: 280px 280px;
	${strictBreakpoints.onlyLgDesktop} {
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	}
	${strictBreakpoints.onlyTablet} {
		grid-auto-rows: minmax(278px, auto);
		grid-template-areas:
			'item1 item1'
			'item2 item3'
			'item4 item5';
		grid-template-columns: 1fr 1fr;
		grid-template-rows: min-content;
	}
	${strictBreakpoints.onlyMobile} {
		grid-auto-rows: minmax(198px, auto);
		grid-gap: 16px;
		grid-template-areas:
			'item1'
			'item2'
			'item3'
			'item4'
			'item5';
		grid-template-rows: min-content;
	}
	${strictBreakpoints.onlyDesktop} {
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	}

	.wrapper {
		.name {
			margin-top: 12px;
			${strictBreakpoints.onlyMobile} {
				letter-spacing: -0.5px;
				word-break: break-all;
			}
		}
	}
`;
